import { useLocation } from "react-router-dom";
// import { useQuery } from "@apollo/react-hooks";
// import gql from "graphql-tag";

import styled from "@emotion/styled";
import { useScrollToTop } from "../lib/react/hooks";
import MainLayout from "../components/layout/MainLayout";
import Button from "../components/Button";

import { ReactComponent as MailSvg } from "../assets/svg/contact-mail.svg";

interface IContactProps {}

export const Contact = (props: IContactProps) => {
  const routerLocation = useLocation();
  useScrollToTop([routerLocation && routerLocation.pathname]);
  return (
    <MainLayout>
      <Column>
        <h2>Kontakta oss</h2>
        <p>Om du behöver hjälp med något så når du oss via e-post, vi besvarar dig vanligtvis inom 24h. </p>
        <a href="mailto:kontakt@atmosphere.nu?subject=Kontakt">
          <WideButton >
            <MailSvg></ MailSvg>
            Skicka ett meddelande
          </WideButton>
        </a>
       <EmergencyText>
        <em>
          Vid akuta ärenden kan ni ringa oss på:{" "}
          <a href="tel:0736771005">073-677 10 05</a>
        </em>
      </EmergencyText>
      </Column>
    </MainLayout>
  );
};

const EmergencyText = styled.p`
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
  color: #333;

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  em {
    color: grey;
  }

  strong {
    font-weight: 600;
  }
`;

const WideButton = styled(Button)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 32px;

  > svg {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    margin-bottom: 2px;
  }
`;

const Column = styled.div`
  padding: 0 20% 15% 20%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;

  > h2 {
    margin-bottom: 45px;
    text-align: center;
  }

  @media (max-width: 600px) {
    padding: 0 8% 15% 8%;
  }
`;

export default Contact;
